import styled from '@emotion/styled'

export const Container = styled.section`
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
`
